<template>
  <div class="filter-section">
    <div class="filter-items">
      <slot name="filters"></slot>
    </div>
    <div class="filter-actions">
      <slot name="actions">
        <button @click="handleReset" class="btn btn-secondary">
          {{ resetText }}
        </button>
      </slot>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  resetText: {
    type: String,
    default: '필터 초기화'
  }
})

const emit = defineEmits(['reset'])

const handleReset = () => {
  emit('reset')
}
</script>

<style scoped>
.filter-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 24px;
}

.filter-items {
  display: flex;
  align-items: center;
  gap: 20px;
}

.filter-actions {
  display: flex;
  gap: 12px;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #5a6268;
}

.btn-primary {
  background: #007bff;
  color: white;
}

.btn-primary:hover {
  background: #0056b3;
}

@media (max-width: 768px) {
  .filter-section {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
  
  .filter-items {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
}
</style>